import {
  Youtube,
  FileText,
  Map,
  MapPinned,
  Utensils,
  Train,
  MessageCircle,
} from "lucide-react";
import { TravelPluginDefinition } from "../types/travel/travelPluginTypes";

export const TRAVEL_PLUGINS: TravelPluginDefinition[] = [
  {
    id: "travel-chat",
    name: "Travel Chat",
    description: "Chat with your travel companions to plan and coordinate your trip together",
    longDescription:
      "Connect with fellow travelers in your project. Share ideas, discuss itineraries, and coordinate plans in real-time with group chat.",
    icon: MessageCircle,
    category: "social",
    status: "available",
    color: "#06b6d4",
    colorEnd: "#0891b2",
    tags: ["chat", "messenger", "collaborate"],
  },
  {
    id: "korea-map",
    name: "Korea Travel Map",
    description: "Color in the Korean cities and counties you visited on this trip",
    longDescription:
      "Track your journey across Korea on an interactive map. Mark the cities and counties you visited, watch your coverage grow, and discover regions you haven't explored yet.",
    icon: Map,
    category: "maps",
    status: "available",
    color: "#3a9d6e",
    colorEnd: "#2e7d52",
    tags: ["map", "regions", "tracker"],
  },
  {
    id: "youtube-summarizer",
    name: "Destination Discovery",
    description: "Search a destination and get AI-curated YouTube travel videos with a digest",
    longDescription:
      "Type a destination like Sydney and get travel vlogs and guides collected from YouTube, summarized and tagged by AI — popular spots, food, itineraries, and practical tips at a glance.",
    icon: Youtube,
    category: "content",
    status: "available",
    color: "#ef4444",
    colorEnd: "#dc2626",
    tags: ["video", "summary", "research"],
  },
  {
    id: "blog-collector",
    name: "Blog Collector",
    description: "Paste a blog URL to organize and save key travel information",
    longDescription:
      "Automatically extract and organize important details from travel blog posts — itineraries, restaurant recommendations, tips, and more.",
    icon: FileText,
    category: "content",
    status: "coming_soon",
    color: "#3b82f6",
    colorEnd: "#2563eb",
    tags: ["blog", "article", "organize"],
  },
  {
    id: "google-saved-places",
    name: "Google Saved Places",
    description: "Connect your Google account to view your saved and starred places",
    longDescription:
      "Import your Google Maps saved places, starred locations, and want-to-go lists directly into your travel project.",
    icon: MapPinned,
    category: "maps",
    status: "coming_soon",
    color: "#22c55e",
    colorEnd: "#16a34a",
    tags: ["google", "maps", "places"],
    requiresAuth: true,
    provider: "Google",
  },
  {
    id: "local-food-finder",
    name: "Local Food Finder",
    description: "Discover popular local restaurants and street food near your destinations",
    icon: Utensils,
    category: "utility",
    status: "coming_soon",
    color: "#f59e0b",
    colorEnd: "#d97706",
    tags: ["food", "restaurant", "local"],
  },
  {
    id: "transit-guide",
    name: "Transit Guide",
    description: "Get public transit routes and tips for getting around Korean cities",
    icon: Train,
    category: "utility",
    status: "coming_soon",
    color: "#8b5cf6",
    colorEnd: "#7c3aed",
    tags: ["transit", "transport", "route"],
  },
];
